import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { withLoading } from '@hems/component';
import { EnergyManagementContainer } from '@hems/container';
import { DeviceServiceUser } from '@hems/service';
import { useUserSiteInfo } from '@hems/util';
import MainTitle from '@/components/title/MainTitle.vue';
export default defineComponent({
    name: 'EnergyManagement',
    components: {
        MainTitle,
        EnergyManagementContainer,
    },
    setup() {
        const deviceServiceUser = new DeviceServiceUser(window.axiosInstance.axios);
        const store = useStore();
        const { masterDeviceInfo } = useUserSiteInfo();
        const siteId = computed(() => masterDeviceInfo.value?.deviceInfo.site_id);
        const operationMode = ref('');
        const isConsumptionCT = computed(() => store.state.device.isConsumptionCT);
        const loadOperationMode = withLoading(async () => {
            try {
                if (siteId.value) {
                    const settingInfo = await deviceServiceUser.getUserACSystemSettingInfo(siteId.value);
                    operationMode.value = String(settingInfo.energy_policy);
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        loadOperationMode();
        return {
            operationMode,
            isConsumptionCT,
        };
    },
});
